import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { XapiXidroService } from '../_services';
import * as XidroActions from '../_actions/xidroDevices';

@Injectable()
export class XidroEffects {
  loadXidroDevices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(XidroActions.loadXidroDevices),
      mergeMap(() =>
        forkJoin({
          pumpSystems: this.xapiXidroService.getPumpSystems(),
          pressureMeters: this.xapiXidroService.getPressureSensors(),
          valves: this.xapiXidroService.getZones(),
          flowMeters: this.xapiXidroService.getFlowMeters(),
        }).pipe(
          map(({ pumpSystems, pressureMeters, valves, flowMeters }) =>
            XidroActions.loadXidroDevicesSuccess({
              pumpSystems,
              pressureMeters,
              valves,
              flowMeters,
            })
          ),
          catchError((error) => of(XidroActions.loadXidroDevicesFailure({ error: error.message })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private xapiXidroService: XapiXidroService
  ) {}
}
